import { get, getOr, constant, map, filter, identity, flow, union } from 'lodash/fp';
import { addConfigurationsToCart } from '../../../api/autobahn';

export default (cartingOptions) => {
  const job = get('job', cartingOptions);

  const productOnlyConfigurations = flow(
    get('productOnlyItems'),
    map(get('itemProduct.configurationGuid')),
  )(cartingOptions);

  const productConfigurations = flow(
    get('items'),
    filter({ type: 'window' }),
    map('productInformation.configurationId'),
    filter(identity),
    union(productOnlyConfigurations),
  )(job);

  const configs = [
    get('id', job),
    ...getOr(false, 'options.cartProducts', cartingOptions) ? productConfigurations : [],
  ];

  return addConfigurationsToCart(configs)
    .then(constant(cartingOptions));
};
